import * as React from 'react'
import Arrow from '../../assets/images/yumuuv_arrow.svg'
import Loader from '../Loader/Loader'
import './ActivityCard.scss'

interface IActivityCardProps {
  className?: string
  isLoading?: boolean
  isGoalSet?: boolean
  children: React.ReactNode
}

export class ActivityCard extends React.PureComponent<IActivityCardProps> {
  BEM = () => {
    const { className } = this.props

    const classArray = ['activity-card']

    if (className) {
      classArray.push(className)
    }

    if (this.props.isGoalSet) {
      classArray.push('activity-card--is-goal-set')
    }

    return classArray.join(' ')
  }

  getActivityCardContentClassName() {
    const classArray = ['activity-card__content']

    if (this.props.isLoading) {
      classArray.push('activity-card__content--is-loading')
    }

    return classArray.join(' ')
  }

  renderContent() {
    const { isLoading, children } = this.props

    return <>{isLoading ? <Loader inverse={true} /> : children}</>
  }

  render() {
    return (
      <div className={this.BEM()}>
        <div className={this.getActivityCardContentClassName()}>{this.renderContent()}</div>
        <img src={Arrow} alt={`YuMuuv arrow`} className="activity-card__arrow" />
        {/*<div className="activity-card__illustration" />*/}
      </div>
    )
  }
}
